// formConfig.js
export const nameConfig = {
  fieldName: "name",
  validationRegex: /^[A-Za-z\s]{3,60}$/,
  validationLetters: /^[A-Za-z\s]+$/,
  validationErrorMessage: "Name should contain only letters",
  lengthErrorMessage: "Name should be between 3 to 60 characters",
};

export const emailConfig = {
  fieldName: "email",
  validationRegex: /^[\w.-]+@[\w.-]+\.\w+$/,
  validationErrorMessage: "Please enter a valid email address",
};

export const phoneConfig = {
  fieldName: "phone",
  validationRegex: /^[0-9]{10}$/,
  validationErrorMessage: "Please enter a valid phone number",
};
